import React from 'react';
import image_home from '../assets/image_home.png';
import '../styles/global.css';

function Home() {
    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div className='headerMain'>
                    <div className='mb2'>
                        <label >Welcome to TaxLowPrices.com</label>
                    </div>
                    <div className=' pr4 pl4'>
                        <img src={image_home} alt="image_home" style={{ width: '100%', height: 'auto', display: 'block', margin: '0 auto' }} />
                    </div>
                    <div className='mt2 pr4 pl4'>
                        <label className='labelTitulo' >We are a group of tax professionals Enrolled Agents whose proposal is to provide reliable tax services at low prices for US individuals and small business.</label>
                    </div>
                </div>
            
            
            </main>
        </div>
    );
}

export default Home;